(() => {
  // app/scripts/search-filter.js
  (() => {
    var PriceRange = class extends HTMLElement {
      constructor() {
        super();
        this.querySelectorAll('input[type="number"]').forEach((element) => element.addEventListener("change", this.onInputChange.bind(this)));
        this.querySelectorAll('input[type="range"]').forEach((element) => element.addEventListener("change", this.onRangeChange.bind(this)));
        this.setMinAndMaxInputValues();
      }
      onInputChange(event) {
        this.adjustToValidValues(event.currentTarget);
        this.setMinAndMaxInputValues();
      }
      onRangeChange(event) {
        this.setMinAndMaxRangeValues();
      }
      setMinAndMaxInputValues() {
        const inputs = this.querySelectorAll('input[type="number"]');
        const ranges = this.querySelectorAll('input[type="range"]');
        const rangeTrack = this.querySelector(".jsRangeTrack");
        const defaultMaxRange = ranges[1].getAttribute("max");
        const minInput = inputs[0];
        const maxInput = inputs[1];
        let minRange = ranges[0];
        let maxRange = ranges[1];
        if (parseInt(maxRange.value) < parseInt(minRange.value)) {
          minRange = ranges[1];
          maxRange = ranges[0];
        }
        if (maxInput.value) {
          maxRange.value = maxInput.value;
          minInput.setAttribute("max", maxInput.value);
        }
        if (minInput.value) {
          minRange.value = minInput.value;
          maxInput.setAttribute("min", minInput.value);
        }
        if (minInput.value === "") {
          maxInput.setAttribute("min", 0);
        }
        if (maxInput.value === "") {
          minInput.setAttribute("max", maxInput.getAttribute("max"));
        }
        const percentMin = parseInt(minRange.value) / parseInt(defaultMaxRange) * 100;
        const percentMax = parseInt(maxRange.value) / parseInt(defaultMaxRange) * 100;
        rangeTrack.style.left = percentMin + "%";
        rangeTrack.style.width = percentMax - percentMin + "%";
      }
      setMinAndMaxRangeValues() {
        const inputs = this.querySelectorAll('input[type="number"]');
        const ranges = this.querySelectorAll('input[type="range"]');
        const rangeTrack = this.querySelector(".jsRangeTrack");
        const defaultMaxRange = ranges[1].getAttribute("max");
        const minInput = inputs[0];
        const maxInput = inputs[1];
        let minRange = ranges[0];
        let maxRange = ranges[1];
        if (parseInt(maxRange.value) < parseInt(minRange.value)) {
          minRange = ranges[1];
          maxRange = ranges[0];
        }
        if (maxRange.value) {
          maxInput.value = maxRange.value;
          minInput.setAttribute("max", maxInput.value);
        }
        if (minRange.value) {
          minInput.value = minRange.value;
          maxInput.setAttribute("min", minInput.value);
        }
        if (minInput.value === "") {
          maxInput.setAttribute("min", 0);
        }
        if (maxInput.value === "") {
          minInput.setAttribute("max", maxInput.getAttribute("max"));
        }
        const percentMin = parseInt(minRange.value) / parseInt(defaultMaxRange) * 100;
        const percentMax = parseInt(maxRange.value) / parseInt(defaultMaxRange) * 100;
        rangeTrack.style.left = percentMin + "%";
        rangeTrack.style.width = percentMax - percentMin + "%";
      }
      set([min, max]) {
        const inputs = this.querySelectorAll('input[type="number"]');
        const ranges = this.querySelectorAll('input[type="range"]');
        const rangeTrack = this.querySelector(".jsRangeTrack");
        const defaultMaxRange = ranges[1].getAttribute("max");
        inputs.forEach((el) => {
          el.value = el.className.toLowerCase().includes("min") ? min : max;
        });
        ranges.forEach((el) => {
          el.value = el.className.toLowerCase().includes("min") ? min : max;
        });
        const percentMin = parseInt(min) / parseInt(defaultMaxRange) * 100;
        const percentMax = parseInt(max) / parseInt(defaultMaxRange) * 100;
        rangeTrack.style.left = percentMin + "%";
        rangeTrack.style.width = percentMax - percentMin + "%";
      }
      reset() {
        const inputs = this.querySelectorAll('input[type="number"]');
        const ranges = this.querySelectorAll('input[type="range"]');
        const rangeTrack = this.querySelector(".jsRangeTrack");
        const defaultMaxRange = ranges[1].getAttribute("max");
        inputs.forEach((el) => {
          el.value = el.className.toLowerCase().includes("min") ? "0" : defaultMaxRange;
        });
        ranges.forEach((el) => {
          el.value = el.className.toLowerCase().includes("min") ? "0" : defaultMaxRange;
        });
        rangeTrack.style.left = "0%";
        rangeTrack.style.width = "100%";
      }
      adjustToValidValues(input) {
        const value = Number(input.value);
        const min = Number(input.getAttribute("min"));
        const max = Number(input.getAttribute("max"));
        if (value < min)
          input.value = min;
        if (value > max)
          input.value = max;
      }
    };
    customElements.define("price-range", PriceRange);
    var customElementTagName = "filter-component";
    !window.customElements.get(customElementTagName) && window.customElements.define(customElementTagName, class extends HTMLElement {
      constructor() {
        super();
        this.addEventListener("input", this.onInput.bind(this));
        this.addEventListener("click", this.onClick.bind(this));
      }
      onClick(e) {
        const { target } = e;
        if (target.closest(".toggle-ymm-filter")) {
          this.classList.toggle("filter-showing");
        }
        if (target.closest(".jsActiveFilters")) {
          this.removeField(target);
        }
        if (target.closest(".reset-filter")) {
          this.resetField();
        }
      }
      onInput(e) {
        if (this.debounce != null)
          clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {
          this.filter();
          this.debounce = null;
        }, 300);
      }
      async filter() {
        const searchResult = document.querySelector(".jsSearchResult");
        const noResult = document.querySelector(".jsNoResult");
        if (searchResult) {
          searchResult.innerHTML = "";
        }
        if (noResult) {
          noResult.innerHTML = "";
        }
        const form = this.querySelector("form");
        const formData = new FormData(form);
        formData.append("section_id", this.dataset.sectionId);
        let searchParams = new URLSearchParams(formData);
        let result = await fetch(`${form.action}?${searchParams}`);
        result = await result.text();
        const div = document.createElement("div");
        div.innerHTML = result;
        div.querySelectorAll(".jsFilterUpdate").forEach((item) => {
          this.renderParts(item);
        });
        formData.delete("section_id");
        searchParams = new URLSearchParams(formData);
        window.history.replaceState({}, "", `${form.action}?${searchParams}`);
      }
      renderParts(newDiv) {
        const currentTarget = document.querySelector(`[class*="${newDiv.className}"]`);
        if (!currentTarget)
          return;
        currentTarget.replaceWith(newDiv);
      }
      removeField(e) {
        e.classList.add("hidden");
        const currentTarget = this.querySelector(`input[name='${e.getAttribute("data-name")}'][value='${e.getAttribute("data-value")}']`);
        if (!currentTarget)
          return;
        if (currentTarget.checked) {
          currentTarget.checked = false;
          this.filter();
        }
      }
      resetField() {
        this.querySelectorAll(".filter-group input:checked")?.forEach((item) => {
          item.checked = false;
        });
        this.querySelector(".jsActiveFilters").innerHTML = "";
        this.querySelector("price-range").reset();
        this.filter();
      }
    });
  })();
})();
